import React, { useEffect, useState } from 'react';
import "./MessageStudents.css";

function MessageStudents(props) {
  const [totalCharCount, setTotalCharCount] = useState(0);
  const [message, setMessage] = useState("");
  const [showSubmitPage, setShowSubmitPage] = useState(false);
  const [infoIconColor, setInfoIconColor] = useState("#558F73");

  useEffect(()=>{
    if(props?.tutorMsg){
        setMessage(props?.tutorMsg)
      }
  },[])

  useEffect(()=>{
    if(totalCharCount === 255){
      setInfoIconColor("#CC405C")
    }else{
      setInfoIconColor("#558F73")
    }
  },[totalCharCount])

  const callback = () => {
    setShowSubmitPage(true);
  }

  const handleEditBtn = () => {
    setShowSubmitPage(false);
    if(props?.onEditMsg) props?.onEditMsg();
  }

  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/\s{2,}/g, ' ');
    if (value[0] === ' ') {
      value = value.trimStart();
    }
    setMessage(value);
    setTotalCharCount(value.length);
  };
  let enableSubmitBtnCheck = totalCharCount > 3 && (props?.tutorMsg?.trim() !== message?.trim());

  return (
      <>
          <div className="overview-message-box">
          <h2>Write a <span>special message</span> to your students. </h2>
          <p>This message will be displayed on the student end till the campaign. </p>
          <div className="overview-special-msg-container">
            {!showSubmitPage && (
                <>
                  <div>
                    <div className='message-text-title'>
                      <p className='message-input-label'>Type here</p>
                      <p className='message-char-count'>{totalCharCount}/255</p>
                    </div>
                    <textarea
                        className='message-textarea'
                        onChange={(e) => {
                          const trimmedValue = e.target.value.trim(); // Trim whitespace from both ends
                          if (trimmedValue.length > 0 || e.target.value === '') {
                            handleInputChange(e)
                          }
                        }}
                        placeholder="Holi Day Special Offer! Celebrate Holi with a special discount of 30% on all our courses.
Use Coupon Code HOLI30 - ABC Teaching
"
                        maxLength={255}
                        value={message}
                    />
                    {totalCharCount === 255 &&
                        <p className="message-description-red">
                    <span style={{marginTop: "3px"}}>
                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.875 0.875C3.97551 0.875 1.625 3.22551 1.625 6.125C1.625 9.0245 3.97551 11.375 6.875 11.375C9.7745 11.375 12.125 9.0245 12.125 6.125C12.125 3.22551 9.7745 0.875 6.875 0.875ZM0.75 6.125C0.75 2.74226 3.49226 0 6.875 0C10.2577 0 13 2.74226 13 6.125C13 9.50774 10.2577 12.25 6.875 12.25C3.49226 12.25 0.75 9.50774 0.75 6.125Z"
                              fill={infoIconColor}/>
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M6.875 4.8125C7.11662 4.8125 7.3125 5.00838 7.3125 5.25V9.625C7.3125 9.86662 7.11662 10.0625 6.875 10.0625C6.63338 10.0625 6.4375 9.86662 6.4375 9.625V5.25C6.4375 5.00838 6.63338 4.8125 6.875 4.8125Z"
                              fill={infoIconColor}/>
                        <path
                            d="M7.53125 3.28125C7.53125 3.64369 7.23744 3.9375 6.875 3.9375C6.51256 3.9375 6.21875 3.64369 6.21875 3.28125C6.21875 2.91881 6.51256 2.625 6.875 2.625C7.23744 2.625 7.53125 2.91881 7.53125 3.28125Z"
                            fill={infoIconColor}/>
                      </svg>
                    </span>Character limit reached!
                        </p>
                    }
                  </div>
                  <button className={enableSubmitBtnCheck ? 'message-send-button' : 'message-send-button disabled'}
                          onClick={enableSubmitBtnCheck ? () => props.onSubmitMessage(message, callback) : null}
                          disabled={totalCharCount < 4}>
                    Submit
                  </button>
                </>
            )
            }
            {showSubmitPage && (
                <div className='message-form-wrapper'>
                  <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/success.gif" alt=''
                       width={70} height={70}/>
                  <p className='message-form-title'>Your message has been submitted successfully!</p>
                  <div className='message-success-container'>
                    <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/edit.svg" alt=''/>
                    <span onClick={handleEditBtn}>Edit Your Message</span>
                  </div>
                </div>
            )}
          </div>
        </div>
      </>
  );
}

export default MessageStudents;
